import { Component, Input, OnInit } from '@angular/core';
import * as Highcharts from 'highcharts';

import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { ColorPalette } from '../../../analytics-core/interfaces/partner.interface';
import { COLORS, EVENT_EMITTERS } from '../../../analytics/constants/analytics.constants';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';

@Component({
	selector: 'app-r10-daypart',
	styleUrls: ['./r10-daypart.component.css'],
	templateUrl: './r10-daypart.component.html'
})
export class R10DaypartComponent implements OnInit {
	@Input() externalwidgetsconfiguration: any;
	@Input() sectiontitle: any;
	public reloadSubscription;
	public widgetDataSubscription;
	public key: string;
	public dayPartData: any;
	public showLoad: boolean = true;
	public hasData: boolean = false;
	public colorPalette: ColorPalette;
	public widgetsConfiguration;
	public tooltipOptions = {
		'hide-delay': 100,
		placement: 'top',
		theme: 'light'
	};
	public timezone: string = '';
	public dayPartFriendlynames = [];
	public initialAxisDataSrc = {
		allowZeroData: true,
		colorPalette: {
			color: '',
			isCustom: false
		},
		dataLabels: {
			enabled: true
		},
		dataType: 'number',
		displayName: '',
		format: '',
		readFrom: 'impressions',
		rowIdentity: {
			key: 'daypart',
			value: ''
		},
		showInSeries: 'true'
	};
	public daypartColors = ['primary', 'secondary', 'tertiary', 'quaternary', 'quinary'];

	constructor(protected analyticsService: AnalyticsService, protected analyticsDataModel: AnalyticsDataModel) {
		this.reloadSubscription = EmitterService.get(EVENT_EMITTERS.RELOAD).subscribe((response: any) => {
			this.requestData();
		});
	}

	ngOnInit(): void {
		this.colorPalette = this.analyticsDataModel.partner.colorPalette;
		this.widgetsConfiguration = this.externalwidgetsconfiguration
			? JSON.parse(decodeURI(this.externalwidgetsconfiguration))
			: null;
		this.requestData();
	}

	ngOnDestroy(): void {
		if (this.reloadSubscription) {
			this.reloadSubscription.unsubscribe();
		}
		if (this.widgetDataSubscription) {
			this.widgetDataSubscription.unsubscribe();
		}
	}

	requestData(): void {
		this.showLoad = true;
		this.hasData = false;
		this.widgetDataSubscription = this.analyticsService.processCustomServiceRequest(this.key).subscribe((res: any) => {
			this.showLoad = false;
			this.timezone = res && res.timezone ? `(${res.timezone})` : '';
			if (res.success && res.data.length > 0) {
				this.hasData = true;
				const res_data = res.success ? res.data : [];
				this.processResponseData(res_data);
			} else {
				this.hasData = false;
			}
		});
	}

	processResponseData(response: any[]): void {
		if (response) {
			this.dayPartData = response;
			this.generateAxisLabelsSoruce();
			this.widgetsConfiguration.chartConfig.dataLabels.formatter = this.getDataLabelFormatter();
			this.widgetsConfiguration.chartConfig.toolTip.formatter = this.getToolTipFormatter();
		}
	}

	generateAxisLabelsSoruce(): void {
		this.widgetsConfiguration.chartConfig.series[0].axisDataSource = [];
		this.dayPartData.forEach((daypart, index) => {
			const axisDataSrc = JSON.parse(JSON.stringify(this.initialAxisDataSrc));
			axisDataSrc.displayName = `${daypart.daypart.toLowerCase()}: ${daypart.friendly_name}`;
			axisDataSrc.rowIdentity.value = daypart.daypart;
			axisDataSrc.colorPalette.color = this.daypartColors[index];
			if (daypart.impressions === '0') {
				axisDataSrc.showInSeries = false;
				axisDataSrc.dataLabels.enabled = false;
			}
			this.widgetsConfiguration.chartConfig.series[0].axisDataSource.push(axisDataSrc);
		});
	}

	getDataLabelFormatter(): any {
		return function (): string {
			return `
				<div style='width: 100%'>
					<div>${this.key.substring(0, this.key.indexOf(':'))}</div>
			</div>`;
		};
	}

	getToolTipFormatter(): any {
		return function (): string {
			return `<div style='width: 9.5rem; padding: 3px'>
				<div style='width: 100%'>
					<div style='width: 50%; display:inline-block; color: ${this.color}'>${this.key}</div>
				</div>
				<div style='width: 100%;'>
					<div style='width: 50%; display:inline-block'>impressions</div>
					<div style='width: 50%; display:inline-block; text-align: right'>${Highcharts.numberFormat(this.y, 0, '', ',')}</div>
				</div>
			</div>`;
		};
	}
}
